var _excluded = ["_content", "children", "_to", "_asChild", "controlledExpanded", "shareExpandedStatus"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useEffect, useState, useMemo } from 'react';
export var getWrappedComponentChildren = function getWrappedComponentChildren(children, _content, _to, expanded, _asChild) {
  var _wrappedComponentChildren;

  var _children = children instanceof Function ? children(expanded) : children;

  if (_asChild) {
    var content = expanded ? _content : null;
    if (_to === 'top') _wrappedComponentChildren = [content, _children];
    if (_to === 'bottom') _wrappedComponentChildren = [_children, content];
  } else {
    _wrappedComponentChildren = [_children];
  }

  return _wrappedComponentChildren;
};
export var getJsx = function getJsx(wrappedComponent, _to, _content, expanded, _asChild) {
  var jsx = null;

  if (_asChild) {
    jsx = wrappedComponent;
  } else {
    if (_to === 'bottom') {
      jsx = /*#__PURE__*/React.createElement(React.Fragment, null, wrappedComponent, expanded && _content);
    }

    if (_to === 'top') {
      jsx = /*#__PURE__*/React.createElement(React.Fragment, null, expanded && _content, wrappedComponent);
    }
  }

  return jsx;
};
export function withExpandable(Component) {
  return /*#__PURE__*/React.forwardRef(function (_ref, ref) {
    var _content = _ref._content,
        children = _ref.children,
        _ref$_to = _ref._to,
        _to = _ref$_to === void 0 ? 'bottom' : _ref$_to,
        _ref$_asChild = _ref._asChild,
        _asChild = _ref$_asChild === void 0 ? false : _ref$_asChild,
        _ref$controlledExpand = _ref.controlledExpanded,
        controlledExpanded = _ref$controlledExpand === void 0 ? false : _ref$controlledExpand,
        shareExpandedStatus = _ref.shareExpandedStatus,
        props = _objectWithoutProperties(_ref, _excluded);

    var _useState = useState(false),
        _useState2 = _slicedToArray(_useState, 2),
        expanded = _useState2[0],
        setExpanded = _useState2[1];

    var wrappedComponentDependencies = [children, _content, _to, expanded, _asChild];
    useEffect(function () {
      setExpanded(controlledExpanded);
    }, [controlledExpanded]);
    var wrappedComponentChildren = useMemo(function () {
      return getWrappedComponentChildren.apply(void 0, wrappedComponentDependencies);
    }, wrappedComponentDependencies);
    var wrappedComponent = useMemo(function () {
      var _Component$displayNam;

      return /*#__PURE__*/React.createElement(Component, _objectSpread({
        key: 'with-expandable-' + ((_Component$displayNam = Component.displayName) !== null && _Component$displayNam !== void 0 ? _Component$displayNam : 'component'),
        ref: ref,
        onClick: function onClick(e) {
          e.stopPropagation();
          var nextIsExpanded = !expanded;
          setExpanded(nextIsExpanded);
          shareExpandedStatus && shareExpandedStatus(nextIsExpanded);
        }
      }, props), wrappedComponentChildren);
    }, [Component, ref, props, wrappedComponentChildren, setExpanded, expanded]);
    var jsxDependencies = [wrappedComponent, _to, _content, expanded, _asChild];
    return useMemo(function () {
      return getJsx.apply(void 0, jsxDependencies);
    }, jsxDependencies);
  });
}
export default withExpandable;